import { serializeAddress, validateCryptoAddress } from "./address-core";
import { normalizeUsername, UsernameSchema } from "@repo/types";

export interface UserProfileHandle {
  readonly kind: "wallet" | "username";
  readonly key: string;
}

export function parseUserProfileHandle(
  param: string | null | undefined,
): UserProfileHandle | null {
  if (!param) return null;
  const handle = param.trim();
  if (validateCryptoAddress(handle).isValid)
    return { kind: "wallet", key: serializeAddress(handle) };
  const username = UsernameSchema.safeParse(handle);
  return username.success
    ? { kind: "username", key: normalizeUsername(username.data) }
    : null;
}
